import { jsx } from "react/jsx-runtime";
import { keyframes, styled, useTheme } from "@mui/material";
import { useMemo } from "react";
const loadAnimation = keyframes`
  from {
    left: var(--startPosition);
  }
  65% {
    left: 100%;
  }
  100% {
    left: var(--startPosition);
  }
`;
const SuperCar = styled("div", {
  skipSx: true,
  name: "SuperCarIndicator",
  slot: "Root"
})`
  animation: ${loadAnimation} infinite var(--duration, 3s);
  background: var(--color);
  position: absolute;
  width: var(--size);
  z-index: 10;
  height: 4px;
  left: 0;
  top: 0;
`;
function useStyles(props) {
  const { size, duration, color } = props;
  return useMemo(() => {
    return {
      root: {
        "--duration": duration ? `${duration}s` : void 0,
        "--startPosition": `-${size}px`,
        "--color": color,
        "--size": `${size}px`
      }
    };
  }, [color, duration, size]);
}
function SuperCarIndicator(props) {
  const { size, duration, color } = props;
  const theme = useTheme();
  const styles = useStyles({
    size,
    duration,
    color: color ?? (theme.vars ?? theme).palette.primary.main
  });
  return /* @__PURE__ */ jsx(SuperCar, { style: styles.root });
}
export {
  SuperCarIndicator
};
//# sourceMappingURL=SuperCarIndicator.js.map
